export enum PaymentFrequencyTypeEnum {
  Quarterly = "Quarterly",
  Monthly = "Monthly",
}
